import type { Image } from '@/api/accommodation/types'

/**
 * The unit named together with its place ("Penzion Žleby – Pokoj 2"). A unit
 * without a name of its own carries the place name, which then stands alone —
 * mirrors the backend `Unit::$fullName`.
 */
export function unitFullName(location: { name: string }, unit: { name: string }): string {
  return unit.name === location.name ? location.name : `${location.name} – ${unit.name}`
}

/**
 * The unit's own photos followed by the place photos. Callers sort by
 * priority, so the merged list gets fresh priorities that keep the unit
 * photos ahead of the place ones.
 */
export function unitPhotos(unit: { photos?: Image[] }, location: { photos?: Image[] }): Image[] {
  const byPriority = (photos?: Image[]) => [...(photos ?? [])].sort((a, b) => b.priority - a.priority)
  const merged = [...byPriority(unit.photos), ...byPriority(location.photos)]
  return merged.map((photo, index) => ({
    ...photo,
    priority: merged.length - index,
  }))
}
